import IconComponent from "icons/IconComponent";

import InformationWhiteIcon from "./information-white-icon.svg";

export default (InformationWhiteIcon as any) as IconComponent;
